import { Component, OnInit } from '@angular/core';

import { WebService } from '../../service/web.service';
import { Web } from './../../models/web';
import {Router} from '@angular/router';

@Component({
  selector: 'app-web-design',
  templateUrl: './web-design.component.html',
  styleUrls: ['./web-design.component.css']
})
export class WebDesignComponent implements OnInit {
  webs: Array<Web> = new Array<Web>();

  constructor(private dataservice: WebService, private Ruta: Router) { }

  ngOnInit(): void {
    this.dataservice.getWb().subscribe(resp => {
      for (const data of resp.body) {
        this.webs.push(data);
      }
    });
  }

  irDetalleWeb(web: Web) {
    this.dataservice.web = web;
    this.Ruta.navigateByUrl('/detail-web/' + this.dataservice.web.tituloProyectoWeb );
  }

}
